<h1 mat-dialog-title>Confirm Subscription</h1>
<p class="warning-msg">
  Your trial will expire now, and you'll be moved to the chosen monthly subscription plan. Would you like to continue?
</p>

<div mat-dialog-actions class="button-section">
  <button mat-button color="primary" (click)="onClick('cancel')">Cancel</button>
  <button mat-flat-button color="primary" (click)="onClick('confirm')">Confirm</button>
</div>
